import type { IconData } from '@stacksjs/iconify-core'

export const toiletSignManRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M18.842 10.16a5.16 5.16 0 1 1 10.318 0a5.16 5.16 0 0 1-10.318 0M24.002 1a9.16 9.16 0 0 0-9.16 9.16c0 2.045.67 3.933 1.804 5.458a6.29 6.29 0 0 0-5.598 7.049c.948 7.809 2.94 14.174 4.454 18.16C16.83 44.323 20 47 24.001 47c4 0 7.17-2.677 8.497-6.172c1.514-3.987 3.506-10.352 4.455-18.161a6.29 6.29 0 0 0-5.596-7.049a9.1 9.1 0 0 0 1.803-5.459C33.16 5.101 29.06 1 24.001 1m-6.878 18.59A90 90 0 0 1 24 19.319c2.612 0 4.993.126 6.876.273c1.315.102 2.268 1.251 2.105 2.593c-.9 7.414-2.793 13.459-4.223 17.224C27.918 41.622 26.066 43 24 43c-2.067 0-3.919-1.379-4.76-3.593c-1.43-3.765-3.322-9.81-4.222-17.223c-.163-1.341.79-2.491 2.105-2.593\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toiletSignManRemix
